module.exports = __webpack_public_path__ + "static/img/coffeeselected.1e7d4057.svg";